import React, { Component } from 'react';
import { SaleContext } from './context';
import { CS_API_URL, parseJwt, CLIENT_API_URL } from '../../lib/env';
import Axios from 'axios';
import { omit } from 'lodash';
import withSeo from '../SeoProvider/withSeo';

const ACTIVE_SALE_ID_STORE = '@active-sale';

class SaleProvider extends Component {
  state = {
    sale: null,
    activeSales: [],
  };

  componentWillReceiveProps(nextProps) {
    // if (nextProps.seo.status && nextProps.seo.status.code === 6 && !this.state.sale) {
    //   this.createOrGetSaleBySeoStatus(nextProps.seo.status);
    // }
    console.log({ nextProps });
  }

  asyncSetState = (state) => new Promise((resolve) => this.setState(state, resolve));

  setSale = (sale) => {
    if (sale) {
      window.sessionStorage.setItem(ACTIVE_SALE_ID_STORE, sale.id);
    } else {
      window.sessionStorage.removeItem(ACTIVE_SALE_ID_STORE);
    }
    return this.asyncSetState({ sale });
  };

  init = () => {
    const activeSaleId = window.sessionStorage.getItem(ACTIVE_SALE_ID_STORE);
    const saleId = parseInt(activeSaleId);

    if (saleId && !isNaN(saleId)) {
      this.getSaleById(saleId);
    } else {
      this.getActiveSalesDeals();
    }
  };

  getSales = (filter) => {
    const token = window.localStorage.getItem('token');

    return Axios.post(
      `${CS_API_URL}/sales/list`,
      {
        statusCodes: ['ACTIVE', 'HOLD', 'PAYMENT', 'MISSED', 'ISSUE', 'SUCCESS', 'LOGIST'],
        ...filter,
        limit: 1,
        offset: 0,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ).then((response) => (response.data ? response.data.listSales || [] : []));
  };

  getActiveSalesDeals = async () => {
    const token = window.localStorage.getItem('token');

    const currentUser = parseJwt(token);

    if (!currentUser || !currentUser.roleList.find(({ code, project }) => ['CS', 'FB'].includes(project.code))) {
      if (this.state.activeSales.length > 0) {
        this.setState({ activeSales: [] });
      }
      return null;
    }
    this.setState({ seoSalesState: 'loading' });
    // const { sale } = this.state;
    const activeSales = await Axios.post(
      `${CS_API_URL}/sales/list`,
      {
        statusCodes: ['ACTIVE'],
        assignTo: currentUser.username,
        limit: 50,
        offset: 0,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ).then((response) => (response.data ? response.data.listSales || [] : []));

    // let activeDeal = { ...sale };
    const seoSales = activeSales.filter((sale) => !sale.online);
    // const activeSaleId = window.sessionStorage.getItem(ACTIVE_SALE_ID_STORE);

    // if (activeSaleId && activeSales && (!sale || !sale.id)) {
    //   activeDeal = activeSales.find((sale) => sale.id === parseInt(activeSaleId, 10));
    //   if (activeDeal && activeDeal.id) {
    //     await this.getSaleById(activeDeal.id);
    //   }
    // }
    this.asyncSetState({ activeSales, seoSales, seoSalesState: 'loaded' });
  };

  createOrGetSaleBySeoStatus = async (seoStatus, clientId) => {
    this.setState({ seoStatus });
    if (seoStatus && seoStatus.clientFields && seoStatus.clientFields.phoneNumber) {
      const sale = await this.getSaleByPhoneNumber(seoStatus.clientFields.phoneNumber);
      if (sale) {
        await this.getSaleById(sale.id);
      } else {
        await this.createSeoSale(seoStatus, clientId);
      }
    }
  };

  createSale = async (data) => {
    const newClient = await Axios.post(`${CLIENT_API_URL}/clients`, data.client, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    }).then((response) => response.data);

    const client = { ...omit(newClient, ['id']), clientId: newClient.id };
    const token = window.localStorage.getItem('token');
    let sale;
    try {
      const found = await this.getSaleByPhoneNumber(client.phoneNumber);
      if (!found) {
        sale = await Axios.post(
          `${CS_API_URL}/sales/createSale`,
          { ...data, client, copyVisitSale: false, carFin: true },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        ).then((response) => response.data);
        await this.setSale(sale);
      } else {
        await this.getSaleById(found.id);
      }
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  };

  createSeoSale = async (seoStatus) => {
    if (!seoStatus) {
      return;
    }

    try {
      const newClient = await Axios.post(
        `${CLIENT_API_URL}/clients`,
        {
          firstName: seoStatus.clientFields.firstName,
          phoneNumber: seoStatus.clientFields.phoneNumber,
          gender: seoStatus.clientFields.gender === 'Женщина' ? 'M' : 'F',
          language: seoStatus.clientFields.language === 'Русский' ? 'RU' : 'KK',
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem('token')}`,
          },
        }
      ).then((response) => response.data);
      const client = { ...omit(newClient, ['id']), clientId: newClient.id };
      const sale = await Axios.post(
        `${CS_API_URL}/sales/createSale`,
        {
          seoNumber: seoStatus.TicketNum,
          client,
          copyVisitSale: false,
          carFin: true,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      ).then((response) => response.data);
      await this.setSale(sale);
    } catch (error) {
      console.error(error);
    }
  };

  getSaleByPhoneNumber = async (phoneNumber) => {
    const [saleByPhoneNumber] = await Axios.post(
      `${CS_API_URL}/sales/list`,
      {
        client: { phoneNumber },
        statusCodes: ['ACTIVE', 'HOLD', 'PAYMENT', 'MISSED', 'ISSUE', 'SUCCESS', 'LOGIST'],
        offset: 0,
        limit: 1,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    ).then((response) => (response.data && response.data.listSales ? response.data.listSales : []));
    if (!saleByPhoneNumber) {
      console.log('По данному номеру телефона отсутствует контакт!');
      return null;
    }
    return saleByPhoneNumber;
  };

  getSaleById = async (saleId) => {
    try {
      const sale = await Axios.get(`${CS_API_URL}/sales/getById/${saleId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then((response) => response.data);
      await this.setSale(sale);
    } catch (error) {
      console.error(error);
    }
  };

  closeSale = async (assignTo) => {
    const currentUser = parseJwt(localStorage.getItem('token'));
    const { sale } = this.state;
    if (!sale || !currentUser) {
      return;
    }

    try {
      const data = { carFin: true };
      if (assignTo) {
        data.assignTo = assignTo.username;
        data.assignToFullName = [assignTo.lastname, assignTo.firstName].filter((name) => !!name).join(' ');
        data.subdivision = assignTo.subdivision;
      } else {
        data.saleStatus = { code: 'HOLD' };
      }
      await Axios.patch(
        `${CS_API_URL}/sales/`,
        {
          id: sale.id,
          ...data,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      await this.setSale();
    } catch (error) {
      console.error(error);
    }
  };

  getClientsByPhoneNumber = (phoneNumber) => {
    return Axios.get(`${CLIENT_API_URL}/clients/getByPhoneNumber/${phoneNumber}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    }).then((response) => {
      if (response.data && response.data.length > 0) {
        return response.data || [];
      }
      return [];
    });
  };

  render() {
    return (
      <SaleContext.Provider
        value={{
          ...this.state,
          createOrGetSaleBySeoStatus: this.createOrGetSaleBySeoStatus,
          createSale: this.createSale,
          closeSale: this.closeSale,
          getSaleById: this.getSaleById,
          getActiveSalesDeals: this.getActiveSalesDeals,
          getSales: this.getSales,
          getClientsByPhoneNumber: this.getClientsByPhoneNumber,
          init: this.init,
        }}
      >
        {this.props.children}
      </SaleContext.Provider>
    );
  }
}

export default withSeo(SaleProvider);
